import React, { useState } from 'react';
import { Box, IconButton, Menu, Tooltip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MyLocationOutlinedIcon from '@mui/icons-material/MyLocationOutlined';
import ActionMenuItem, { ACTION_MENU_LIST_PROPS, ACTION_MENU_PAPER_PROPS } from '../ActionMenuItem';
import RecordLotIdentity, { recordCardHeaderIconSx } from '../RecordLotIdentity';
import {
  getRecordCardLocateActiveSx,
  listCardActionIconSx,
} from '../UserLotListsPanel/UserLotListsPanel.styles';
import {
  filterResultCardActionsSx,
  filterResultCardHeaderSx,
  filterResultCardSx,
} from './FilterResultsPanel.styles';

const TYPE_LABELS = {
  URBANO: 'Urbano',
  SUBURBANO: 'Suburbano',
  'SUB URBANO': 'Suburbano',
  'SUB-URBANO': 'Suburbano',
  RURAL: 'Rural',
  SUBRURAL: 'Subrural',
  'SUB RURAL': 'Subrural',
  'SUB-RURAL': 'Subrural',
};

const formatType = (type) => {
  if (!type) return null;
  const key = String(type).trim();
  return TYPE_LABELS[key] || TYPE_LABELS[key.toUpperCase()] || key;
};

const formatSurface = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return `${n.toLocaleString('es-AR', { maximumFractionDigits: 2 })} m²`;
};

/** Bandas de `val_b` del tile; no es el USD exacto del detalle. */
const VALUATION_BAND_LABELS = {
  0: '< USD 10k',
  1: 'USD 10k–30k',
  2: 'USD 30k–60k',
  3: 'USD 60k–120k',
  4: '≥ USD 120k',
};

const formatValuationBand = (value) => VALUATION_BAND_LABELS[value] || null;

/**
 * Línea de datos del tile: tipo · superficie · banda de valuación.
 * La ubicación (departamento · provincia) va en la línea de lugar de `RecordLotIdentity`.
 * @param {object} lot
 * @returns {string}
 */
export function formatFilterResultMeta(lot) {
  return [formatType(lot?.type), formatSurface(lot?.urbansurface), formatValuationBand(lot?.val_b)]
    .filter(Boolean)
    .join(' · ');
}

/**
 * Card de una parcela filtrada en la vista. Misma identidad que Registros e
 * Historial. Los tiles no traen calle ni contenido de usuario: título catastral,
 * lugar y datos del tile. ⋮ solo con Ubicar («Ver lote» = tocar la card).
 */
export default function FilterResultsLotCard({ lot, locateActive = false, onOpenLot, onLocateLot }) {
  const [menuAnchor, setMenuAnchor] = useState(null);
  const closeMenu = () => setMenuAnchor(null);
  return (
    <Box
      component="li"
      onClick={() => onOpenLot?.(lot.lot_id)}
      data-testid="filter-result-card"
      data-located={locateActive ? 'true' : undefined}
      sx={{ ...filterResultCardSx, ...(locateActive ? getRecordCardLocateActiveSx() : {}) }}
    >
      <Box sx={filterResultCardHeaderSx}>
        <RecordLotIdentity lot={lot} metaLine={formatFilterResultMeta(lot) || null} />
        <Box onClick={(e) => e.stopPropagation()} sx={filterResultCardActionsSx}>
          <Tooltip title="Más acciones" placement="top" arrow>
            <IconButton
              size="small"
              onClick={(e) => setMenuAnchor(e.currentTarget)}
              sx={{ ...listCardActionIconSx, ...recordCardHeaderIconSx }}
              aria-label="Más acciones"
            >
              <MoreVertIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={closeMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={ACTION_MENU_PAPER_PROPS}
            MenuListProps={ACTION_MENU_LIST_PROPS}
          >
            <ActionMenuItem
              onClick={() => {
                closeMenu();
                onLocateLot?.(lot.lot_id, lot);
              }}
              icon={<MyLocationOutlinedIcon sx={{ fontSize: 20 }} />}
              label={locateActive ? 'Quitar marca del mapa' : 'Ubicar en el mapa'}
            />
          </Menu>
        </Box>
      </Box>
    </Box>
  );
}
